export const faqItems = [
  {
    question: 'Reçetesiz gözlük alabilir miyim?',
    questionEn: 'Can I buy glasses without a prescription?',
    answer:
      'Evet, güneş gözlüğü ve sıfır numaralı moda gözlükleri reçetesiz satın alabilirsiniz. Numaralı gözlükler için ise göz muayenesi veya geçerli bir reçete gereklidir.',
    answerEn:
      'Yes, you can buy sunglasses and zero-power fashion glasses without a prescription. Prescription glasses require an eye exam or a valid prescription.',
  },
  {
    question: 'Lens değişimi ne kadar sürer?',
    questionEn: 'How long does lens replacement take?',
    answer:
      'Standart lens değişimleri 3-5 iş günü, özel progresif veya ince lensler 5-7 iş günü içinde tamamlanır. Acil durumlarda ekspres hizmet seçeneğimiz mevcuttur.',
    answerEn:
      'Standard lens replacements take 3-5 business days, special progressive or thin lenses 5-7 days. Express service is available for urgent cases.',
  },
  {
    question: 'Garanti koşulları nelerdir?',
    questionEn: 'What are the warranty terms?',
    answer:
      'Tüm ürünlerimiz orijinal ve garantilidir. Çerçevelerde üretici garantisi, lenslerde ise kırılma ve çizilme garantisi sunuyoruz. Satış sonrası ücretsiz ayar hizmetimiz sürekli devam eder.',
    answerEn:
      'All our products are original and guaranteed. Manufacturer warranty on frames, breakage and scratch warranty on lenses. Free adjustment service continues after purchase.',
  },
  {
    question: 'Çocuk gözlüğü var mı?',
    questionEn: 'Do you have children\'s glasses?',
    answer:
      'Evet, Fisher Price ve diğer markaların çocuk koleksiyonlarını mağazamızda bulabilirsiniz. Çocuklara özel dayanıklı çerçeveler ve güvenli lens seçenekleri sunuyoruz.',
    answerEn:
      'Yes, we carry children\'s collections from Fisher Price and other brands with durable frames and safe lens options.',
  },
  {
    question: 'Taksit imkânı var mı?',
    questionEn: 'Is installment payment available?',
    answer:
      'Evet, anlaşmalı banka kredi kartlarına taksit imkânı sunuyoruz. Detaylı bilgi için mağazamızı arayabilir veya WhatsApp üzerinden bize ulaşabilirsiniz.',
    answerEn:
      'Yes, installment options are available with partner bank credit cards. Contact us for details.',
  },
  {
    question: 'Numaralı güneş gözlüğü yapılıyor mu?',
    questionEn: 'Can you make prescription sunglasses?',
    answer:
      'Evet, reçetenize uygun numaralı güneş gözlüğü lensleri hazırlıyoruz. Polarize ve renkli lens seçenekleri mevcuttur.',
    answerEn:
      'Yes, we prepare prescription sunglass lenses. Polarized and tinted lens options are available.',
  },
  {
    question: 'Göz muayenesi ücretli mi?',
    questionEn: 'Is the eye exam paid?',
    answer:
      'Mağazamızda yapılan temel göz muayenesi ücretsizdir. Gözlük satın alımıyla birlikte kapsamlı muayene hizmeti sunuyoruz.',
    answerEn:
      'Basic eye examination at our store is free. Comprehensive exam service is included with glasses purchase.',
  },
  {
    question: 'Satın aldığım gözlüğü ayarlatmak için gelmem gerekir mi?',
    questionEn: 'Do I need to come in for adjustments?',
    answer:
      'Gözlüğünüzün rahat oturması için ayar gerektiğinde mağazamıza ücretsiz olarak gelebilirsiniz. Vida, burunluk ve sap ayarları hızlıca yapılır.',
    answerEn:
      'You can visit our store for free adjustments when needed. Screw, nose pad and temple adjustments are done quickly.',
  },
];
